export const authRoles = {
  ADMIN: 'Admin',
  MANUFACTURE: 'Manufacture',
  MANUFACTURING_STAFF: 'Manufacturing_staff',
}

export const roles = [
  {
    label: authRoles.ADMIN,
  },
  {
    label: authRoles.MANUFACTURE,
  },
]

export const warehouses = [
  {
    id: 1,
    name: 'General',
  },
]

export const defaultCharacters = {
  ENTRY: 'Entrada',
  OUTPUT: 'Salida',
}

export const baseProps = {
  isOpen: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    default: 'add',
  },
}

export const months = {
  es: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  en: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
}

export const defaultPagination = {
  current_page: 1,
  from: 1,
  last_page: 1,
  per_page: 10,
  total: 0,
}

export const recordActions = {
  actived: 'actived',
  active: 'active',
  inactived: 'inactived',
  inactive: 'inactive',
  cancel: 'cancel',
  approve: 'approve',
  applied: 'applied',
  apply: 'apply',
  added: 'added',
  substracted: 'substracted',
  send: 'send',
  receive: 'receive',
  'in-transit': 'in-transit',
  delete: 'delete',
  show_history: 'history',
  show_payments: 'payments',
  completed: 'completed',
  quoting: 'quoting',
  'po-pending': 'po-pending',
  'upload-po': 'upload-po',
  'in-production': 'in-production',
  finish: 'finish',
  invalidate: 'invalidate',
} as const

export const receptionsStatuses = [
  { id: 8, name: 'APPLIED', color: 'bg-green-50 text-green-600' },
  { id: 9, name: 'PENDING', color: 'bg-orange-50 text-orange-600' },
]
export const cutlists = [
  { value: 1, name: 'Si' },
  { value: 0, name: 'No' },
]
export const scrapStatus = [
  { value: 1, name: 'Si' },
  { value: 0, name: 'No' },
]

export const purchaseStatuses = [
  { id: 3, name: 'DRAFTED', color: 'bg-gray-50 text-gray-600' },
  { id: 4, name: 'APPROVED', color: 'bg-blue-50 text-blue-600' },
  { id: 5, name: 'RECEIVED', color: 'bg-green-50 text-green-600' },
  { id: 7, name: 'CANCELLED', color: 'bg-red-50 text-red-600' },
  { id: 13, name: 'IN_TRANSIT', color: 'bg-orange-50 text-orange-600' },
  { id: 14, name: 'QUOTING', color: 'bg-blue-50 text-blue-600' },
  { id: 15, name: 'OC_PENDING', color: 'bg-orange-50 text-orange-600' },
  { id: 16, name: 'WITH_PO', color: 'bg-green-50 text-green-600' },
  { id: 17, name: 'IN_PRODUCTION', color: 'bg-yellow-50 text-yellow-600' },
  { id: 18, name: 'FINISHED', color: 'bg-green-50 text-green-600' },
  { id: 19, name: 'INVALIDATE', color: 'bg-purple-50 text-purple-600' },
]

export const statuses: Record<any, any> = {
  RECEIVED: 'status.RECEIVED',
  ACTIVED: 'status.ACTIVED',
  IN_PROCESS: 'status.IN_PROCESS',
  DRAFTED: 'status.DRAFTED',
  INACTIVED: 'status.INACTIVED',
  CANCELLED: 'status.CANCELLED',
  APPROVE: 'status.APPROVE',
  APPROVED: 'status.APPROVED',
  APPLIED: 'status.APPLIED',
  PENDING: 'status.PENDING',
  SENT: 'status.SENT',
  IN_TRANSIT: 'status.IN_TRANSIT',
  COMPLETED: 'status.DONE',
  QUOTING: 'status.QUOTING',
  PO_PENDING: 'status.OC_PENDING',
  WITH_PO: 'status.WITH_PO',
  IN_PRODUCTION: 'status.IN_PRODUCTION',
  FINISHED: 'status.FINISHED',
  INVALIDATE: 'status.INVALIDATE',
}

export const defaultStatuses = {
  RECEIVED: 'RECEIVED',
  ACTIVED: 'ACTIVED',
  IN_PROCESS: 'IN_PROCESS',
  DRAFTED: 'DRAFTED',
  INACTIVED: 'INACTIVED',
  CANCELLED: 'CANCELLED',
  APPROVE: 'APPROVE',
  APPROVED: 'APPROVED',
  APPLIED: 'APPLIED',
  PENDING: 'PENDING',
  SENT: 'SENT',
  IN_TRANSIT: 'IN_TRANSIT',
  QUOTING: 'QUOTING',
  PO_PENDING: 'PO_PENDING',
  WITH_PO: 'WITH_PO',
  'IN-PRODUCTION': 'IN_PRODUCTION',
  FINISHED: 'FINISHED',
  INVALIDATE: 'INVALIDATE',
}

export const statusesList = Object.keys(defaultStatuses)

export const statusesIds = {
  drafted: 3,
  approved: 4,
  received: 5,
  cancelled: 7,
  in_transit: 13,
  quoting: 14,
  'po-pending': 15,
  'upload-po': 16,
  'in-production': 17,
  finished: 18,
  invalidate: 19,
}

export const defaultOrder = {
  icon: 'pi-arrow-up',
  name: 'Fecha de creación',
  value: 'created_at,asc',
}

export const countries = [
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Brazil', code: 'BR' },
  { name: 'Brunei', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cabo Verde', code: 'CV' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo (Congo-Brazzaville)', code: 'CG' },
  { name: 'Congo (DRC)', code: 'CD' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czechia', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Eswatini', code: 'SZ' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Greece', code: 'GR' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea (North)', code: 'KP' },
  { name: 'Korea (South)', code: 'KR' },
  { name: 'Kosovo', code: 'XK' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Laos', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia', code: 'FM' },
  { name: 'Moldova', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montenegro', code: 'ME' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar (Burma)', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'North Macedonia', code: 'MK' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestine', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russia', code: 'RU' },
  { name: 'Rwanda', code: 'RW' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia', code: 'RS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Sudan', code: 'SS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syria', code: 'SY' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States', code: 'US' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Vatican City', code: 'VA' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Vietnam', code: 'VN' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
]

export const availableCatalogs = {
  unit_of_measurements: 1,
  currencies: 2,
  types: 3,
  raw_material: 4,
  finished_matter: 5,
  gauge: 6,
  galvanized: 7,
  hardness: 8,
  color_types: 23,
  width: 27,
  payment_types: 31,
  foot_weight: 36,
  kg_square: 40,
}

export const catalogsNames = {
  1: 'unit_of_measurements',
  2: 'currencies',
  3: 'types',
  4: 'raw_material',
  5: 'finished_matter',
  6: 'gauge',
  7: 'galvanized',
  8: 'hardness',
  9: 'color_types',
  10: 'width',
}

export const availableColors = {
  ppc: 24,
  ppw: 25,
  ga: 26,
}

export const paymentType = [
  { id: 1, name: 'Cantidad' },
  { id: 2, name: 'Porcentaje' },
]

export const paymentMethodDefault = [
  { id: 1, name: 'Transferencia' },
  { id: 2, name: 'Efectivo' },
  { id: 3, name: 'Crédito' },
  { id: 4, name: 'Stock' },
]
export const paymentTypeIds = {
  quantity: 1,
  percentage: 2,
}

export const nationalKgSquares: Record<number, string> = {
  12: '10.02',
  13: '8.30',
  24: '0',
}
